import config from '../ConfigProvider'
import AnalyticsService from './AnalyticsService'
import { ApplicationInsightsProvider } from './ApplicationInsightsProvider'
import { HubspotProvider } from './HubspotProvider'
import { MixPanelProvider } from './MixPanelProvider'
import { PostHogProvider } from './PostHogProvider'

/**
 * initAnalytics
 * Helper method to instantiate Analytics Service with all in the included providers
 * Be sure to call initProviders()!
 */
const initAnalytics = (): AnalyticsService => {
  const enableDebugLogging = config.environment === 'local' // enable while developing to show analytics console logs
  const sendTrackingData = config.enableAnalytics === 'true'

  const analyticsService = new AnalyticsService(
    enableDebugLogging,
    sendTrackingData
  )

  const mp = new MixPanelProvider(enableDebugLogging, sendTrackingData)
  mp.tokenId = config.mixPanelToken
  analyticsService.registerProvider('MixPanel', mp)

  const aip = new ApplicationInsightsProvider(
    enableDebugLogging,
    sendTrackingData
  )
  aip.tokenId = config.appInsightsInstrumentationKey
  analyticsService.registerProvider('ApplicationInsights', aip)

  const hubspotProvider = new HubspotProvider(
    enableDebugLogging,
    sendTrackingData
  )
  hubspotProvider.tokenId = config.hubspotAppId
  analyticsService.registerProvider('HubspotProvider', hubspotProvider)

  // Initialize PostHog if enabled
  if (config.posthogEnabled === 'true' && config.posthogApiKey) {
    const postHogProvider = new PostHogProvider(
      enableDebugLogging,
      sendTrackingData
    )
    postHogProvider.tokenId = config.posthogApiKey
    postHogProvider.apiHost = config.posthogApiHost || 'https://app.posthog.com'
    analyticsService.registerProvider('PostHog', postHogProvider)
  }

  analyticsService.initProviders()
  return analyticsService
}

const analyticsServiceSingleton = initAnalytics()
export default analyticsServiceSingleton
